// import Swiper JS
import Swiper, { Navigation, Pagination, Mousewheel, Autoplay } from 'swiper';

const $ = window.jQuery;

const caseSwiper = {
	init() {
		var $heroSwiper = $(document).find('.kundcaseSwiperContainer');

		if (!$heroSwiper.length) return;

		// configure Swiper to use modules
		Swiper.use([Navigation, Pagination, Mousewheel, Autoplay]);

		const swiper = new Swiper('.caseSwiper', {
			slidesPerView: 1,
			spaceBetween: 20,
			loop: true,
			infinit: false,
			autoHeight: true,

			cache: true,
			observer: true,
			observeParents: true,
			mousewheel: {
				forceToAxis: true,
			},
			autoplay: {
				delay: 6500,
				disableOnInteraction: false,
			},
			breakpoints: {
				// when window width is >= 320px
				0: {
					slidesPerView: 1.5,
					centeredSlides: true,
					spaceBetween: 10,
					autoHeight: true,
					loop: true,
					cache: true,
					observer: true,
					observeParents: true,
				},
				// when window width is >= 480px
				480: {
					slidesPerView: 1.5,
					centeredSlides: true,
					spaceBetween: 10,
					loop: true,
					autoHeight: true,
					cache: true,
					observer: true,
					observeParents: true,
				},
				// when window width is >= 640px
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
					autoHeight: true,
					cache: true,
					observer: true,
					observeParents: true,
				},
				// when window width is >= 840px
				940: {
					slidesPerView: 3,
					spaceBetween: 40,
					autoHeight: true,
					cache: true,
					observer: true,
					observeParents: true,
				},
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				init: function (swiper) {
					$heroSwiper.on('click', '.readMoreBt', function () {
						console.log('click');
						const $container = $(this).parent();
						const $dots = $container.find('.dots');
						const $hiddenText = $container.find('.hidden-text');
						$container.toggleClass('active');
						if ($container.hasClass('active')) {
							$(this).text('Stäng text');
							$dots.hide();
							$hiddenText.removeClass('hidden');
							swiper.update();
							return;
						}

						$(this).text('Läs mer');
						$dots.show();
						$hiddenText.addClass('hidden');
						swiper.update();

						return;
					});
					console.log('test');
				},
			},
		});

		swiper.on('init', function (swiper) {
			$('.read-more-contaiener button').on('click', function () {
				const $container = $(this).parent();
				const $dots = $container.find('.dots');
				const $hiddenText = $container.find('.hidden-text');
				$container.toggleClass('active');
				if ($container.hasClass('active')) {
					$(this).text('Stäng text');
					$dots.hide();
					$hiddenText.removeClass('hidden');
					swiper.update();

					return;
				}

				$(this).text('Läs mer');
				$dots.show();
				$hiddenText.addClass('hidden');
				swiper.update();

				return;
			});
		});
	},
};

export default caseSwiper;
